export default __webpack_public_path__ + "static/audio-cardio-6-a-412532dc00ef79fb1192658420b312c6.webp";